<template>
	<div class="page">
		<!-- your page -->
		<div class="list">
			<div class="item" v-for="item in list" :data-id="item.id" @click="goParticulars">
				<div class="avatar" :data-id="item.id">
					<img :src="item.avatar" alt="" :data-id="item.id">
				</div>
				<div class="price" :data-id="item.id">
					<div class="priceBox" :data-id="item.id" v-if="url!='score'">
						¥{{item.price}}
					</div>
					<div class="priceBox" :data-id="item.id" v-if="url=='score'">
						{{item.price}}积分
					</div>
					<div class="sales" :data-id="item.id">
						{{item.sale}}人付款
					</div>
				</div>
				<div class="name" :data-id="item.id">
					{{item.name}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'commodityList',
		props:["commodity"],
		data(){
			return {
				list:[],
				url:""
			}
		},
		methods:{
			setData(){
				this.list = this.$props.commodity
			},
			goParticulars(e){
				var id = e.target.dataset.id
				this.$router.push({path:'/particulars',query:{cid:id,from:this.url}})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.url = window.location.href.split('/#/')[1].split('?')[0]
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.list{
		width: 100%;
		font-size: 0px;
		letter-spacing: -6px;
	}
	.item{
		width: 216px;
		height: 300px;
		display: inline-block;
		vertical-align: top;
		letter-spacing: normal;
		margin-left: 20px;
		margin-top: 20px;
		padding: 0px 5px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.item:hover{
		background: #F0F0F0;
		box-shadow: 3px 3px 3px #E3E3E3;
	}
	.avatar{
		width: 100%;
		height: 210px;
		overflow: hidden;
	}
	.avatar img{
		width: 100%;
		display: block;
	}
	.price{
		width: 100%;
		height: 30px;
		line-height: 30px;
	}
	.priceBox{
		width: 65%;
		height: 100%;
		float: left;
		font-size: 14px;
		color: red;
	}
	.sales{
		width: 35%;
		height: 100%;
		float: left;
		text-align: right;
		color: #838383;
		font-size: 12px;
	}
	.name{
		width: 100%;
		height: 50px;
		line-height: 25px;
		font-size: 14px;
		overflow: hidden;
	}
</style>
